// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__fafM-","ripple":"Button_ripple__1MMt3","loading":"Button_loading__1zAjh"};